import { Outlet, useNavigation } from 'react-router-dom'
import '../Layout.css'
import Loading from '../components/layout/Loading';

function RootLayout() {
    const navigation = useNavigation()
    return <>
        {navigation.state === 'loading' ?
            <Loading /> :
            <Outlet />
        }
    </>
}

export default RootLayout